import Components from "./components";
import {dollarOrPointsFilter, DollarOrPointsFilter} from "./filters/DollarOrPointsFilter";
import {TradingAlertService} from "./services/TradingAlertService";
import {ruleTypeDisplay, RuleTypeDisplay} from "./filters/RuleTypeDisplayFilter";
import {TradingAlertStatisticsService} from "./services/TradingAlertStatisticsService";
import {TradingAlertDialogService} from "./services/TradingAlertDialogService";
import {ruleDisplay, RuleDisplay} from "./filters/RuleDisplayFilter";
import {TradingAlertViewDialogService} from "./services/TradingAlertViewDialogService";

const rootDir = "app/trading-alerts";

export default angular.module("tfApp.trading-alerts", [Components(rootDir)])
                      .filter(DollarOrPointsFilter, dollarOrPointsFilter)
                      .filter(RuleTypeDisplay, ruleTypeDisplay)
                      .filter(RuleDisplay, ruleDisplay)
                      .service(TradingAlertService.id, TradingAlertService)
                      .service(TradingAlertStatisticsService.id, TradingAlertStatisticsService)
                      .service(TradingAlertDialogService.id, TradingAlertDialogService)
                      .service(TradingAlertViewDialogService.id, TradingAlertViewDialogService)
                      .name;
